import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/future-value-calculator',
  component: () => import('../../routes/FutureValueCalculator.svelte'),
  card: {
    id: 'future-value-calculator',
    title: 'Future Value Calculator',
    description: 'Calculate the future value of your investments with an initial lump sum and regular contributions. See how consistent investing grows your wealth over time.',
    icon: 'trending_up',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/future-value-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Future Value Calculator – Lump Sum & Contribution Growth',
    description: 'Free future value calculator. Calculate how your investments will grow with an initial lump sum and regular contributions compounded over time. See year-by-year breakdown and total interest earned.',
  },
};

export default meta;
